/* tslint:disable */
/* eslint-disable */
/**
 * Store
 * 店舗向けAPI
 *
 * The version of the OpenAPI document: 1.0
 * Contact: kiuchi@wcdi.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { SendResetMailRequest } from './SendResetMailRequest';
import {
    SendResetMailRequestFromJSON,
    SendResetMailRequestFromJSONTyped,
    SendResetMailRequestToJSON,
} from './SendResetMailRequest';

/**
 * 
 * @export
 * @interface UpdateUserEmailRequest
 */
export interface UpdateUserEmailRequest {
    /**
     * 
     * @type {SendResetMailRequest}
     * @memberof UpdateUserEmailRequest
     */
    user?: SendResetMailRequest;
}

/**
 * Check if a given object implements the UpdateUserEmailRequest interface.
 */
export function instanceOfUpdateUserEmailRequest(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function UpdateUserEmailRequestFromJSON(json: any): UpdateUserEmailRequest {
    return UpdateUserEmailRequestFromJSONTyped(json, false);
}

export function UpdateUserEmailRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateUserEmailRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'user': !exists(json, 'user') ? undefined : SendResetMailRequestFromJSON(json['user']),
    };
}

export function UpdateUserEmailRequestToJSON(value?: UpdateUserEmailRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'user': SendResetMailRequestToJSON(value.user),
    };
}

